module.exports = __webpack_public_path__ + "img/svg/avatar.34e87169d57c641fc5492e834516f50b.svg";